import { render, staticRenderFns } from "./GatewayDetails.vue?vue&type=template&id=23c60a4e&scoped=true"
import script from "./GatewayDetails.vue?vue&type=script&lang=js"
export * from "./GatewayDetails.vue?vue&type=script&lang=js"
import style0 from "./GatewayDetails.vue?vue&type=style&index=0&id=23c60a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c60a4e",
  null
  
)

export default component.exports